export const GRAIN_CONVEYORS = 'Grain Conveyors'
export const GRAIN_ELEVATORS = 'Grain Elevators'
export const INCLINE_CONVEYORS = 'Incline Conveyors'
export const GRAIN_AUGERS = 'Grain Augers'